<template>
  <div v-observer-log="sailing_c_x_realexposure_sw">
    <dl
      class="item-card card-hover"
      @click="handleSelectBox"
      :class="itemData.headImg || itemData.status === 2 ? '' : 'item-card-max'"
    >
      <dt>
        <div class="content">
          <p
            class="title"
            :class="isShortDesc && (isTips || isSpecial) ? '' : 'title-max'"
          >
            <span v-if="cartHasObj && cartHasObj.amount">{{
              cartHasObj.amount
            }}</span
            >{{ itemData.itemName }}
          </p>
          <p class="desc">{{ itemData.shortDesc }}</p>
          <p
            class="item-price"
            :class="isTips || isSpecial ? '' : 'item-price-max'"
            v-if="itemData.specialPrice !== -1"
          >
            <span class="price">{{ itemData.specialPriceDisplay }}</span>
            <s
              v-if="itemData.specialPrice !== itemData.price"
              class="crossed-price"
              >{{ itemData.priceDisplay }}
            </s>
          </p>
          <p
            class="item-price"
            :class="isTips || isSpecial ? '' : 'item-price-max'"
            v-else
          >
            {{ itemData.priceDisplay }}
          </p>
          <p
            :class="isOpenCard ? 'tips' : 'tips tips-hide'"
            v-if="itemData.tips && itemData.tips.length"
          >
            <i class="icon-filled_special"></i>{{ itemData.tips[0].content }}
          </p>
          <div v-if="isSpecial" class="tips tips-flex">
            <LimitTxt
              v-if="specialIcon"
              :content="specialIcon"
              class="special-icon"
            />
            <LimitTxt v-if="specialContent" :content="specialContent" />
          </div>
        </div>
        <el-button
          outline
          :class="isOpenCard ? 'btn' : 'btn hide-btn'"
          @click.stop="handleSelectBtn"
          >{{ $t('添加') }}</el-button
        >
      </dt>
      <dd>
        <img
          v-if="itemData.headImg"
          v-lazy="itemData.headImg"
          data-width="180"
          :alt="itemData.itemName"
          :title="itemData.itemName"
        />
        <!-- 菜品状态 -->
        <div class="item-hide" v-if="itemData.status === 2">
          <div class="item-hide-div">
            <p v-if="itemData.soldStatus === 2">{{ $t('已售罄') }}</p>
            <p v-if="itemData.soldStatus === 3">{{ itemData.soldTimeDesc }}</p>
          </div>
        </div>
      </dd>
    </dl>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Emitter from '@/mixins/emitter';
import { errImgBase64 } from '@/directives/imgError/conf';
import LimitTxt from '@/components/CateResult/limittxt.vue';
const CATE_ACT_TYPE_CONFIG = {
  SPECIAL: {
    //特价
    type: 2,
    dataName: 'special',
  },
  BUY_GIFT: {
    //买赠
    type: 2,
    dataName: 'buyGift',
  },
};
export default {
  name: 'ItemCard',
  mixins: [Emitter],
  props: {
    itemData: {
      type: Object,
      default: () => {},
    },
    // 调用指定名称的父级的方法：组件名称
    componentName: {
      type: String,
      default: 'Store',
    },
    cateId: {
      type: String,
      default: '',
    },
    position: {
      type: Number,
      default: 1,
    },
    cateIndex: {
      type: Number,
      default: 1,
    },
  },
  components: {
    LimitTxt,
  },
  data() {
    return {
      status: {
        1: '', //正常售卖
        2: '', //异常状态
      },
      soldStatus: {
        1: '', //销售中
        2: this.$t('已售罄'),
        3: this.$t('待售'),
      },
      errImg: errImgBase64,
    };
  },
  computed: {
    ...mapState({
      shopInfo: ({ store }) => store.shopInfo,
      cartData: ({ cart }) => cart.cartInfo,
    }),
    cartHasObj() {
      const obj = this.cartData?.items?.find(
        (i) => i.itemId === this.itemData?.itemId
      );
      return obj;
    },
    isOpenCard() {
      return this.itemData?.status === 1 && this.shopInfo?.cShopStatus === 1;
    },
    isShortDesc() {
      return this.itemData.shortDesc;
    },
    isTips() {
      return this.itemData.tips && this.itemData.tips.length;
    },
    specialContent() {
      return this.itemData?.actTag?.[0]?.content;
    },
    specialIcon() {
      return this.itemData?.actTag?.[0]?.icon;
    },
    isSpecial() {
      return (
        Number(this.itemData?.activityType) ===
        CATE_ACT_TYPE_CONFIG.SPECIAL.type
      );
    },
    sailing_c_x_realexposure_sw() {
      const {
        shopId,
        currency,
        cShopStatus,
        deliveryPriceOri,
        deliveryPriceAct,
        distance,
        deliveryTime,
        deliveryType,
      } = this.shopInfo;
      const {
        itemId,
        contentList,
        status,
        soldStatus,
        soldTimeDesc = '', // 可售卖时间段	V1.2.48新增，当天待售菜品展示售卖时间段
        headImg = '',
        node,
      } = this.itemData;
      const data = {
        eventId: 'sailing_c_x_realexposure_sw',
        eventLabel: '店铺内菜品实曝光',
        attrs: {
          shop_id: shopId,
          shop_status: cShopStatus,
          delivery_fee: `${currency}_${deliveryPriceOri}_${deliveryPriceAct}`,
          delivery_distance: distance,
          delivery_time: deliveryTime,
          delivery_type: deliveryType,
          item_id: itemId,
          item_status: status,
          item_position: this.position,
          sold_status: soldStatus,
          limited_time: soldTimeDesc,
          tab_id: this.cateId,
          tab_position: this.cateIndex,
          item_has_picture: headImg ? 1 : 0,
          has_multi_content: contentList?.length ? 1 : 0,
          if_mutiply_level: node?.totalLevel === 1 ? 0 : 1,
        },
      };

      return data;
    },
  },
  mounted() {},
  methods: {
    handleSelectBtn() {
      const CK_DATA = this.$utils.cloneDeep(this.sailing_c_x_realexposure_sw);
      CK_DATA.eventId = 'sailing_c_x_shop_item_add_ck';
      CK_DATA.eventLabel = '店铺内菜品点击add';

      this.$trackEvent(CK_DATA);

      if (this.itemData.status !== 1 || this.shopInfo.cShopStatus !== 1) return;
      this.dispatch(this.componentName, 'on-select-goods-btn', [
        this.itemData,
        {
          position: this.position,
          cateId: this.cateId,
          cateIndex: this.cateIndex,
        },
        this.$utils.cloneDeep(this.sailing_c_x_realexposure_sw),
      ]);
    },
    handleSelectBox(target) {
      const CK_DATA = this.$utils.cloneDeep(this.sailing_c_x_realexposure_sw);
      CK_DATA.eventId = 'sailing_c_x_shop_item_ck';
      CK_DATA.eventLabel = '店铺内菜品点击';
      CK_DATA.attrs.click_type = 1;

      try {
        const url = target['path'][0].getAttribute('src');
        url && (CK_DATA.attrs.click_type = 2);
      } catch (error) {
        console.log(error);
      }

      this.$trackEvent(CK_DATA);
      this.dispatch(this.componentName, 'on-select-goods-box', [
        this.itemData,
        {
          position: this.position,
          cateId: this.cateId,
          cateIndex: this.cateIndex,
        },
        this.$utils.cloneDeep(this.sailing_c_x_realexposure_sw),
      ]);
    },
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss">
.item-card .tips .line span {
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: break-all;
  word-wrap: break-word;
  display: inline-block;
  width: 150px;
  overflow: hidden;
  font-family: 'Aspira Medium';
}
@media screen and (max-width: 768px) {
  .item-card .tips .line span {
    width: rem(440);
  }
}
</style>
